import { FormModel } from './FormModel';
import { action, computed, makeObservable } from 'src_common/common/mobx-wrapper';
import { FormInputState } from '.';

type FormBoxType<K> = FormInputState<K> | FormModel<K>;

export class FormGroupArray<K> {
    private readonly visitedWhenAllVisited: boolean;
    public readonly fields: ReadonlyArray<FormBoxType<K>>;

    public constructor(fields: ReadonlyArray<FormBoxType<K>>, visitedWhenAllVisited: boolean = true) {
        this.visitedWhenAllVisited = visitedWhenAllVisited;
        this.fields = fields;
        makeObservable(this);
    }

    @action public setAsVisited(): void {
        for (const item of this.fields) {
            item.setAsVisited();
        }
    }

    @action public reset(): void {
        for (const item of this.fields) {
            item.reset();
        }
    }

    @computed public get modifiedStatus(): boolean {
        for (const item of this.fields) {
            if (item.modifiedStatus) {
                return true;
            }
        }

        return false;
    }

    @computed public get isVisited(): boolean {
        if (this.visitedWhenAllVisited) {
            //wszystkie musza być odwiedzone żeby ta grupa była traktowana jako odwiedzona
            for (const item of this.fields) {
                if (item.isVisited === false) {
                    return false;
                }
            }

            return true;
        } else {
            for (const item of this.fields) {
                if (item.isVisited === true) {
                    return true;
                }
            }

            return false;
        }
    }
}
